import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  purchaseOrders : [],
  selectedPurchaseOrder : null,
  selectedPurchaseOrderHistoricActivities : [],
  selectedIndex : null,
  orderBy:{orderName : 'created_at',  direction:'DESC'},
  outDated : true,
  loading : false,
  mode : 'tile',
  loadingSelectedPurchaseOrder : false,
  searchTerms :'',
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  page : 1,
  pages : 0, //nombre de page total
  count : 0,
  limit : 50,
  inventoryId : null,
  filters : {
    status : [],
    date : null,
    year : null,
    availabilityDate : null,
    availabilityYear : null,
  },
  selectedPurchaseOrderProductItems: null,
  selectedPurchaseOrderProducts: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
